<template>
  <div class="plan-con">
    <vs-row style="margin-top: -15px;margin-bottom: 15px">
      <vs-button @click="back()" size="small">{{
        $t("message.back")
      }}</vs-button>
    </vs-row>
    <vs-table :data="data" stripe>
      <template slot="header">
        <vs-row vs-type="flex" vs-align="center" style="margin-bottom: 10px">
          <vs-col vs-w="8">
            <span :class="isMobile() ? 'titleMob' : 'title'" v-if="data[0]"
              >{{ lang == "en" ? data[0].name : data[0].name_zh.tran() }} -
              {{ $t("message.overview") }}</span
            >
          </vs-col>
          <vs-col vs-w="4" vs-type="flex" vs-justify="flex-end">
            <vs-button
              size="small"
              color="rgb(37, 105, 193)"
              @click="download()"
              >{{ $t("message.quarterFundOverview") }}
            </vs-button>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th>
          {{ $t("message.customerCode") }}
        </vs-th>
        <vs-th>
          {{ $t("message.currency") }}
        </vs-th>
        <vs-th>
          {{ $t("message.validDate") }}
        </vs-th>
        <vs-th>
          {{ $t("message.expiryDate") }}
        </vs-th>
        <vs-th>
          {{ $t("message.balanceAmount") }}
        </vs-th>
        <vs-th>
          {{ $t("message.expectedAnnualReturn") }}
        </vs-th>
        <vs-th>
          {{ $t("message.actualAnnualReturn") }}
        </vs-th>
        <vs-th>
          {{ $t("message.beneficiary") }}
        </vs-th>
        <vs-th>
          {{ $t("message.beneficiaryDeath") }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data.customer" v-if="data[indextr].customer">
            {{ data[indextr].customer.code }}
          </vs-td>

          <vs-td :data="data[indextr].currency">
            {{ data[indextr].currency }}
          </vs-td>

          <vs-td :data="data[indextr].effectiveDate">
            {{ data[indextr].effectiveDate | dateFormat }}
          </vs-td>
          <vs-td :data="data[indextr].expiryDate">
            {{ data[indextr].expiryDate | dateFormat }}
          </vs-td>
          <vs-td :data="data[indextr].amount">
            {{ data[indextr].amount }}
          </vs-td>
          <vs-td :data="data[indextr].expectedAnnualReturn">
            {{ data[indextr].expectedAnnualReturn }}
          </vs-td>
          <vs-td :data="data[indextr].actualAnnualReturn">
            {{ data[indextr].actualAnnualReturn }}
          </vs-td>
          <vs-td :data="data[indextr].beneficiaries">
            <div v-if="tr.beneficiaries && tr.beneficiaries[0]">
              {{ data[indextr].beneficiaries.join(", ").tran() }}
            </div>
            <div v-else>
              {{ data[indextr].beneficiary.tran() }}
            </div>
          </vs-td>
          <vs-td :data="data[indextr].beneficiariesAfterDeath">
            <div
              v-if="tr.beneficiariesAfterDeath && tr.beneficiariesAfterDeath[0]"
            >
              {{ data[indextr].beneficiariesAfterDeath.join(", ").tran() }}
            </div>
            <div v-else>
              {{ data[indextr].beneficiaryAfterDeath.tran() }}
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-table
      :data="dividends"
      stripe
      class="m-t-2 scroll-table"
      v-if="dividends.length > 0"
    >
      <template slot="header">
        <vs-row vs-type="flex" vs-align="center" style="margin-bottom: 10px">
          <vs-col vs-w="8">
            <span :class="isMobile() ? 'titleMob' : 'title'" v-if="dividends">{{
              $t("message.dividend")
            }}</span>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th>
          {{ $t("message.periods") }}
        </vs-th>
        <vs-th>
          {{ $t("message.dividendDate") }}
        </vs-th>
        <vs-th>
          {{ $t("message.interest1") }}
        </vs-th>
        <vs-th>
          {{ $t("message.manageFee1") }}
        </vs-th>
        <vs-th>
          {{ $t("message.grossInterest") }}
        </vs-th>
        <vs-th>
          {{ $t("message.accumulated") }}
        </vs-th>
        <vs-th>
          {{ $t("message.rolloverAmount") }}
        </vs-th>
        <vs-th style="min-width: 80px !important;">
          {{ $t("message.status") }}
        </vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="tr._id" v-for="(tr, indextr) in dividends">
          <vs-td>
            {{ indextr + 1 }}
          </vs-td>
          <vs-td :data="tr.datePayable">
            {{ tr.datePayable | dateFormat }}
          </vs-td>
          <vs-td :data="tr.interest">
            {{ tr.interest | priceFormat }}
          </vs-td>
          <vs-td :data="tr.managementFee">
            {{ tr.managementFee | priceFormat }}
          </vs-td>
          <vs-td :data="tr.grossInterest">
            {{ tr.grossInterest | priceFormat }}
          </vs-td>
          <vs-td :data="tr.accumulated">
            {{ tr.accumulated | priceFormat }}
          </vs-td>
          <vs-td :data="tr.rolloverAmount">
            {{ tr.rolloverAmount | priceFormat }}
          </vs-td>
          <vs-td :data="tr.status" style="width: 150px">
            <div>
              {{
                tr.status == "on hold"
                  ? $t("message.onHold")
                  : $t(`message.${tr.status}`)
              }}
              <!-- <feather-icon icon="EditIcon"></feather-icon> -->
            </div>
          </vs-td>
          <vs-td style="white-space: nowrap">
            <ChangeStatus
              :data="tr.status"
              @update="$event = onApproveOne(tr._id, $event)"
            />
            <!-- <div v-if="tr.status === 'pending'">
              <vs-button
                v-role="['admin']"
                @click="onApproveOne(tr._id, 'approved')"
                size="small"
                color="rgb(37, 105, 193)"
                style="margin-right: 10px"
              >
                <feather-icon icon="CheckIcon"></feather-icon>
                <span>{{ $t("message.approve") }}</span>
              </vs-button>
              <vs-button
                v-role="['admin']"
                @click="onApproveOne(tr._id, 'rejected')"
                size="small"
                color="danger"
                style="margin-right: 10px"
              >
                <feather-icon icon="XIcon"></feather-icon>
                <span>{{ $t("message.reject") }}</span>
              </vs-button>
            </div>
            <vs-button
              v-role="['admin']"
              v-if="tr.type === 'Settlement' && tr.status === 'approved'"
              @click="onComplete(tr)"
              color="rgb(37, 105, 193)"
              size="small"
              >{{ $t("message.complete") }}</vs-button
            > -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-row class="m-t-3">
      <vs-col>
        <span :class="isMobile() ? 'titleMob' : 'title'">{{
          $t("message.details")
        }}</span>
      </vs-col>
    </vs-row>
    <vs-card>
      <vs-list class="detail">
        <vs-list-item
          :title="item.title"
          v-for="(item, index) in detail"
          :key="item.id"
          :class="{ bg: index % 3 == 0 }"
        >
          {{
            item.amount && item.amount != 0
              ? $t(`message.${data[0].currency}`) + item.amount
              : item.amount == 0
              ? 0
              : "---"
          }}
        </vs-list-item>
      </vs-list>
    </vs-card>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="flex-end">
        <span class="time" v-if="data[0]"
          >{{ $t("message.lastUpdate") }}:
          {{ data[0].updatedAt | timeFormat }}</span
        >
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ChangeStatus from "../../components/ChangeStatus.vue";

export default {
  props: ["id"],
  data() {
    return {
      lang: "",
      idx: null,
      data: [],
      detail: [],
      dividends: [],
    };
  },
  components: {
    ChangeStatus,
  },
  created() {
    this.lang = this.$cookies.get("lang");
    this.token = this.$cookies.get("token");
    let url =
      process.env.VUE_APP_API_BASEURL +
      "/api/plan/" +
      this.$route.params.id +
      "?access_token=" +
      this.$cookies.get("token");

    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        this.data.push(result.responseDetail);
        this.dividends = result.responseDetail.dividends || [];
        this.detail = [
          {
            id: 1,
            title: this.$t("message.totalConFromEffectiveDate"),
            amount:
              result.responseDetail.totalNetContributionSinceEffectiveDate &&
              result.responseDetail.totalNetContributionSinceEffectiveDate
                .toLocaleString
                ? result.responseDetail.totalNetContributionSinceEffectiveDate.toLocaleString()
                : "",
          },
          {
            id: 2,
            title: "- " + this.$t("message.totalConTransInAssets"),
            amount:
              result.responseDetail.totalTransferAsset &&
              result.responseDetail.totalTransferAsset.toLocaleString
                ? result.responseDetail.totalTransferAsset.toLocaleString()
                : "",
          },
          {
            id: 3,
            title: "- " + this.$t("message.totalWithTransOutAssets"),
            amount:
              result.responseDetail.totalTransferOutAsset &&
              result.responseDetail.totalTransferOutAsset.toLocaleString
                ? result.responseDetail.totalTransferOutAsset.toLocaleString()
                : "",
          },
          {
            id: 4,
            title: this.$t("message.profitorLossFromEffectiveDate"),
            amount:
              result.responseDetail.investmentBalanceSinceEffectiveDate &&
              result.responseDetail.investmentBalanceSinceEffectiveDate
                .toLocaleString
                ? result.responseDetail.investmentBalanceSinceEffectiveDate.toLocaleString()
                : "",
          },
          {
            id: 5,
            title: "- " + this.$t("message.accountBalance"),
            amount:
              result.responseDetail.balance &&
              result.responseDetail.balance.toLocaleString
                ? result.responseDetail.balance.toLocaleString()
                : "",
          },
          {
            id: 6,
            title: "- " + this.$t("message.accountReturns"),
            amount:
              result.responseDetail.return &&
              result.responseDetail.return.toLocaleString
                ? result.responseDetail.return.toLocaleString()
                : "",
          },
        ];
      });
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    onReload() {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/plan/" +
        this.$route.params.id +
        "?access_token=" +
        this.$cookies.get("token");
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          this.dividends = result.responseDetail.dividends || [];
        });
    },
    onComplete(item) {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/dividend/" +
        item._id +
        "/complete?access_token=" +
        this.token;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, *!/!*",
          "Content-Type": "application/json",
        },
        body: null,
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          if (result.responseCode === 200) {
            this.$vs.notify({
              title: "提示",
              text: this.$t("message.complete"),
              icon: "done",
              color: "success",
              position: "top-center",
              time: 3000,
            });
            this.onReload();
          } else {
            this.$vs.notify({
              title: "提示",
              text: result.responseMsg + ". " + result.responseDetail,
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        });
    },
    onApproveOne(id, state) {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/dividend/" +
        id +
        "/approveOne?access_token=" +
        this.token;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, *!/!*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          state: state,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          if (result.responseCode === 200) {
            this.$vs.notify({
              title: "提示",
              text: this.$t(`message.${state}`),
              icon: "done",
              color: "success",
              position: "top-center",
              time: 3000,
            });
            this.onReload();
          } else {
            this.$vs.notify({
              title: "提示",
              text: result.responseMsg + ". " + result.responseDetail,
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        });
    },
    download() {
      if (this.data[0].quarterlyFundOverview) {
        window.open(this.data[0].quarterlyFundOverview.fileUrl);
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
  filters: {
    nameFormat: function(val) {
      if ($cookies.get("role") == "agent") {
        let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
        let patrn1 = /(Mrs|Mr|Miss|Ms|Own)/i;
        if (!patrn.exec(val)) {
          if (patrn1.exec(val.split(" ")[0])) {
            return val;
          } else {
            return val.split(" ")[0] + " XX";
          }
        } else {
          return val[0] + "XX";
        }
      }
      return val;
    },
  },
};
</script>

<style>
@import "../../assets/css/table.css";
@import "../../assets/css/alert.css";
.agTable .ag-theme-material {
  font-family: inherit;
  color: rgba(0, 0, 0, 0.6) !important;
}

.bg {
  background: whitesmoke;
}

.detail .vs-list--title {
  color: #959595;
  font-weight: 500 !important;
}

.detail .vs-list--item {
  height: 35px;
  font-size: 14px;
  color: rgb(37, 105, 193);
  border-bottom: none !important;
}
.status-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<style scoped>
.feather-icon {
  vertical-align: middle;
  margin-right: 3px;
  width: 1.2rem;
  height: 1.2rem;
}
.feather-icon svg {
  color: white;
}
</style>
